import Axios from "axios";

export default function setup() {
  // Add request interceptors
  Axios.interceptors.request.use(
    (config) => {
      config.headers["Source"] = "insight-factory";
      config.withCredentials = true;
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Add response interceptors
  Axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
}
